import React, { useState, useEffect } from 'react';
import {
  FormGroup, Label, Input, Modal, ModalHeader, ModalBody,
}
  from 'reactstrap';
import PropTypes from 'prop-types';
import { useMutation } from 'react-apollo';
import { useToasts } from 'react-toast-notifications';
import * as _ from 'lodash';
import ArtistRegisterForm from './ArtistRegisterForm';
import ManagerRegisterForm from './ManagerRegisterForm';
import {
  getLocalUserData, staticConstants, Messages, handleGraphqlError, routeConstants, history,
} from '../../../utils';
import { MANAGER_REGISTER_MUTATION, LOADER_MUTATION } from '../../../graphql-client/mutations';


function RegisterForm(props) {
  const userData = getLocalUserData();
  const formType = { artist: '1', manager: '2' };
  const [activeRegisterForm, setActiveRegisterForm] = useState(formType.artist);
  const { isOpen, invitationData, hash } = props;
  const [loaderValue, setLoaderValue] = useState(false);
  const [apiData, setApiData] = useState();
  const [fromInvitation, setFromInvitation] = useState();
  const { addToast } = useToasts();


  /* ---- Register mutation ----*/


  const toggle = () => {
    props.onClose(false);
    if ((activeRegisterForm === formType.artist || activeRegisterForm === formType.manager) && apiData) {
      history.replace(routeConstants.REGISTER_SUCCESS);
    } else {
      history.replace('');
    }
  };
  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: loaderValue },
  });
  const [managerRegister] = useMutation(MANAGER_REGISTER_MUTATION, {
    variables: apiData,

    onError(error) {
      setLoaderValue(false);
      loaderMutate();
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      setLoaderValue(false);
      loaderMutate();
      if (activeRegisterForm !== formType.artist) {
        addToast(Messages.registerSuccess, { appearance: 'success' });
      }
      if (data && data.signUp.data && invitationData) {
        const user = data.signUp.data;
        const { token } = user;
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', token);
        const pathToRedirect = routeConstants.CREATE_PASSWORD;
        const path = user.isFirstTime ? routeConstants.CREATE_PASSWORD : pathToRedirect;
        history.push(path);
        return;
      }
      toggle();
    },

  });

  useEffect(() => {
    if (props && props.invitationData && !fromInvitation) {
      if (props.invitationData.role === staticConstants.ROLE.MANAGER || hash === '#artistRegister') {
        setFromInvitation(staticConstants.ROLE.MANAGER);
        setActiveRegisterForm(formType.artist);
      } else {
        setFromInvitation(staticConstants.ROLE.ARTIST);
        setActiveRegisterForm(formType.manager);
      }
    } else if (hash) {
      hash === '#artistRegister' && setActiveRegisterForm(formType.artist);
      hash === '#managerRegister' && setActiveRegisterForm(formType.manager);
    }
  }, [props]);
  const onSubmitCallBack = (data) => {
    if (invitationData) {
      data = { ...data, ...{ token: invitationData.invitationToken } };
    }
    setApiData(data);

    setLoaderValue(true);
    loaderMutate();
    managerRegister();
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-signup" keyboard={false}>
      <ModalHeader toggle={toggle} className="modal-blank-header" />
      <ModalBody>
        <>
          {!userData
            && (
              <p className="font-caveat">
                BYGmusic is a social influencer company that uses you as a musician to promote brands on your social media in an authentic way.
                If this is this something you are interested in, Sign up as an artist or a label.
              </p>
            )}
        </>
        <FormGroup className={`select-user ${userData ? 'mt-0' : ''}`}>
          {!fromInvitation && (
            <>
              <Label>
                <Input
                  type="radio"
                  name="register"
                  value={formType.artist}
                  onChange={(e) => setActiveRegisterForm(e.target.value)}
                  checked={activeRegisterForm === formType.artist}
                />
                <span>{staticConstants.TITLE.ARTIST}</span>
              </Label>
              <Label>
                <Input
                  type="radio"
                  name="register"
                  value={formType.manager}
                  checked={activeRegisterForm === formType.manager}
                  onChange={(e) => setActiveRegisterForm(e.target.value)}
                />
                <span>{staticConstants.TITLE.MANAGER}</span>
              </Label>
            </>
          )}
          {fromInvitation
            && (
              <Label>
                <span>
                  {fromInvitation === staticConstants.ROLE.ARTIST
                    ? staticConstants.TITLE.MANAGER : staticConstants.TITLE.ARTIST}
                </span>
              </Label>
            )}

        </FormGroup>
        <div className={activeRegisterForm !== formType.manager ? 'd-none' : ''}>
          <ManagerRegisterForm
            toggle={toggle}
            submitCallBack={onSubmitCallBack}
            invitationData={invitationData && _.pick(invitationData, ['email', 'name', 'managerFirstName', 'managerLastName', 'country', 'city', 'state',
              'contactNumber', 'primaryContactName', 'genre', 'bio', 'socialMedia', 'profileImage', 'artistImage', 'managerImage', 'companyName'])}
          />
        </div>

        <div className={activeRegisterForm !== formType.artist ? 'd-none' : ''}>
          <ArtistRegisterForm toggle={toggle} invitationData={invitationData && _.pick(invitationData, ['email'])} submitCallBack={onSubmitCallBack} />
        </div>
      </ModalBody>
    </Modal>
  );
}

RegisterForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  invitationData: PropTypes.object,
  hash: PropTypes.string,
};

RegisterForm.defaultProps = {
  invitationData: null,
  hash: null,
};
export default React.memo(RegisterForm);
